import filter from '@/api/filter'
export default (vm, payStatus, row, list) => {
    return [{
        title: {
            label: "基本信息",
        },
        data: [
            {
                readonly: true,
                name: "订单ID",
                key: "id",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "订单号",
                key: "orderNo",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "创建时间",
                key: "orderTime",
                value: "",
                type: -1,
                render(h, item) {
                    if (item.value) {
                        const time = filter.filterTime(item.value, 'YYYY-MM-DD HH:mm')
                        return <span>{time}</span>
                    }
                }
            },
            {
                readonly: true,
                name: "支付时间",
                key: "payTime",
                value: "",
                hidden: list.status == 2 || list.status == 3 ? false : true,
                type: -1,
                render(h, item) {
                    if (item.value) {
                        console.log(item.value)
                        if(item.value == '-'){
                            return <span></span>

                        }else{
                            const time = filter.filterTime(item.value, 'YYYY-MM-DD HH:mm')
                            return <span>{time}</span>
                        }
                        
                    }
                }
            },
            // {
            //     readonly: true,
            //     name: "支付方式",
            //     key: "payStyle",
            //     value: "",
            //     type: 1,
            //     hidden: payStatus == 1 ? true : false
            // },
            {
                readonly: true,
                name: "产品名称",
                key: "productName",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "归属业务员",
                key: "salesmanName",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "所属团队",
                key: "groupName",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "所属机构",
                key: "orgName",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "保障期限",
                key: "guarateeLimit",
                value: "",
                type: 1,
                render(h, item) {
                    const type = row.guarateeType
                    let res = ''
                    if (type == 1) {
                        res = '保终身'
                    } else if (type == 2) {
                        res = `保${item.value}岁`
                    } else if (type == 3) {
                        res = `保${item.value}年`
                    } else if (type == 4) {
                        res = `保${item.value}个月`
                    } else if (type == 5) {
                        res = `保${item.value}天`
                    }
                    return <span>{res}</span>
                }

            },
            {
                readonly: true,
                name: "起保日期",
                key: "effectiveDate",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "终保日期",
                key: "expirationDate",
                value: "",
                type: 1,
            },
            // {
            //     readonly: true,
            //     name: "犹豫期截止日",
            //     key: "hesitateDate",
            //     value: "",
            //     type: 1,
            //     render(h, item) {
            //         const value = filter.filterTime(item.value, 'YYYY-MM-DD')
            //         return <span>{value}</span>;
            //     }
            // },
            {
                readonly: true,
                name: "总保费",
                key: "fee",
                value: "",
                type: 1,
                txt: "元"
            },
            {
                readonly: true,
                name: "交费方式",
                // key: "payType",
                key: "payTypeDesc",
                value: "",
                type: 1,
                // render(h, item) {
                //     const value = filter.filterPayType(item.value)
                //     return <span>{value}</span>;
                // }
            },
            {
                readonly: true,
                name: "交费期限",
                // key: "payLimit",
                key: "payLimitDesc",
                value: "",
                type: 1,
                // render(h, item) {
                //     const res = item.value
                //     if (res && res != '-') {
                //         return <span>{res + '年'}</span>
                //     } else {
                //         return <span>-</span>
                //     }
                // }

            },
            // {
            //     readonly: true,
            //     name: "订单来源",
            //     key: "channelSign",
            //     value: "",
            //     type: 1,
            // },
            {
                readonly: true,
                name: "状态",
                key: "status",
                value: "",
                type: 1,
                render(h, item) {
                    let value = "";
                    const payStatus = item.value;
                    const checkStaus = row.checkInsuranceStatus;
                    const result = filter.filterOrderStatus(payStatus);
                    // 1 核保成功 2 人工核保中 3 核保失败 4 已撤单
                    if (payStatus != 1) {
                        value = result;
                    } else {
                        // const arr = ["核保成功", "人工核保中", "核保失败", "已撤单"];
                        let typeName = "";
                        if (checkStaus == "0") {
                            typeName = "待核保";
                        } else if (checkStaus == "1") {
                            typeName = "核保成功";
                        } else if (checkStaus == "2") {
                            typeName = "人工核保中";
                        } else if (checkStaus == "3") {
                            typeName = "核保失败";
                        } else if (checkStaus == "4") {
                            typeName = "已撤单";
                        } else if (checkStaus == "10") {
                            typeName = "预核保成功";
                        } else if (checkStaus == "-3") {
                            typeName = "预核保失败";
                        }
                        
                        if (checkStaus == 1) {
                            value = "未支付";
                        } else {
                            // const other = arr[checkStaus - 1];
                            const other = typeName;
                            value = result + "-" + other;
                        }
                    }

                    return <span>{value}</span>;
                    // const value = filter.filterOrderDetailStatus(item.value)
                    // return <span>{value}</span>;
                }
            },
        ],
    }, {
        title: {
            label: "投保人信息",
        },
        data: [
            {
                readonly: true,
                name: "姓名",
                key: "name",
                value: "",
                type: 1,

            },
            {
                readonly: true,
                name: "性别",
                key: "sex",
                value: "",
                type: 1,
                render(h, item) {
                    const value = filter.filterSex(item.value)
                    return <span>{value}</span>;
                }
            },
            {
                readonly: true,
                name: "证件类型",
                key: "cardType",
                value: "",
                type: 1,
                render(h, item) {
                    const value = filter.filterCardType(item.value)
                    return <span>{value}</span>;
                }
            },
            {
                readonly: true,
                name: "证件号",
                key: "cardNumber",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "手机号码",
                key: "mobile",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "电子邮箱",
                key: "email",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "所在地区",
                key: "area",
                value: "",
                type: 1,
            },
            {
                readonly: true,
                name: "详细地址",
                key: "address",
                value: "",
                type: 1,
            },

        ],
    }]
}